import { Link } from 'react-router';
import { HeaderBar } from '../components/HeaderBar.tsx';
import { Icon } from '../components/Icon.tsx';

export function More() {
  const betaMonitor =
    typeof localStorage !== 'undefined' && localStorage.getItem('lt-beta-monitor') === '1';
  const rows = [
    { to: '/growth', icon: <Icon.chart s={18} />, label: 'Growth' },
    { to: '/milestones', icon: <Icon.sparkle s={18} />, label: 'Milestones' },
    { to: '/health', icon: <Icon.heart s={18} />, label: 'Health' },
    { to: '/events', icon: <Icon.clock s={18} />, label: 'Events log' },
    { to: '/family', icon: <Icon.user s={18} />, label: 'Family' },
    ...(betaMonitor
      ? [{ to: '/monitor', icon: <Icon.bell s={18} />, label: 'Baby Monitor (Beta)' }]
      : []),
    { to: '/settings', icon: <Icon.gear s={18} />, label: 'Settings' },
  ];
  return (
    <>
      <HeaderBar title="More" showAvatar={false} />
      <div className="lt-scroll" style={{ flex: 1, padding: '0 16px' }}>
        <div className="lt-card" style={{ overflow: 'hidden' }}>
          {rows.map((r, i) => (
            <Link
              key={r.to}
              to={r.to}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: 12,
                padding: '14px 16px',
                color: 'var(--text-1)',
                textDecoration: 'none',
                borderTop: i === 0 ? 'none' : '1px solid var(--divider)',
              }}
            >
              <span style={{ color: 'var(--text-2)' }}>{r.icon}</span>
              <span style={{ flex: 1, fontWeight: 500 }}>{r.label}</span>
              <Icon.chevR s={16} style={{ color: 'var(--text-3)' }} />
            </Link>
          ))}
        </div>
      </div>
    </>
  );
}
